const getAbcWallet = () => {
  const abcUser = JSON.parse(window.localStorage.getItem('abcUser') as string);
  const isSns = window.localStorage.getItem('login') === 'sns';
  if (abcUser?.twoFactorEnabled && isSns) return { isAbcReady: true, abcAddress: abcUser?.accounts[0]?.ethAddress };
  return { isAbcReady: false, abcAddress: abcUser?.accounts[0]?.ethAddress };
};

export default getAbcWallet;
